import React from "react";

const Eye = ({ isEye, onClick,style={ top: "50%" } }) => {
  return (
    <i
      className={`fa-solid ct_eye_show ${!isEye ? "fa-eye-slash" : "fa-eye"}`}
      onClick={() => onClick(!isEye)}
      style={style}
    ></i>
  );
};

export default Eye;
